import { render, staticRenderFns } from "./MarketingLogo.vue?vue&type=template&id=07384d8a&scoped=true&"
import script from "./MarketingLogo.vue?vue&type=script&lang=js&"
export * from "./MarketingLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07384d8a",
  null
  
)

export default component.exports